"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Col = _interopRequireDefault(require("react-bootstrap/lib/Col"));
/** A set of columns to guide element placement
 */


var Col = function Col(_ref) {
  var children = _ref.children,
      htmlId = _ref.htmlId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "htmlId"]);
  delete props.bsClass;
  return _react["default"].createElement(_Col["default"], Object.assign({
    id: htmlId
  }, props), children);
};

Col.defaultProps = {
  componentClass: "div"
};
var _default = Col;
exports["default"] = _default;